export default "__VITE_ASSET__36cea2b8__"